import React from 'react';
import {View} from 'react-native';
import {get, isNil, noop} from 'lodash';

import PersonListItem from '/component/base/PersonListItem';
import Gutter from '/component/layout/Gutter';
import {CLIENT_PROFILE} from '/enum/recordType.enum';

import {styles} from './OrdersReportListItem.style';
import {
  getPersonAvatarEmail,
  getPersonAvatarUrl,
} from './OrdersReportListItem.util';
interface ReportItem {
  id: number;
  firstName: string;
  lastName: string;
  lastOrderedOn: string;
  orderDate: string;
  entryDate: string;
}
interface OrdersReportListItemProps {
  alternateItemKey: string | null;
  index: number | null;
  item: ReportItem;
  onRecordPress: () => void;
  PersonInfoComponent: React.ComponentType<{item: ReportItem}> | null;
  personIsCoach: (item: ReportItem) => boolean;
  PersonNameComponent: React.ComponentType<{item: ReportItem}> | null;
  PersonRoleComponent: React.ComponentType<{item: ReportItem}> | null;
  NewLabelComponent: React.ComponentType<{item: ReportItem}> | null;
  hasHorizontalPadding: boolean;
  isPeopleToContactSection: boolean;
}

export const OrdersReportListItem: React.FC<OrdersReportListItemProps> = ({
  alternateItemKey = null,
  index = null,
  item = {},
  onRecordPress = noop,
  PersonInfoComponent = null,
  personIsCoach = noop,
  PersonNameComponent = null,
  PersonRoleComponent = null,
  NewLabelComponent = null,
  hasHorizontalPadding = false,
  isPeopleToContactSection = false,
}) => {
  let rowStyle = {...styles.row};
  if (index > 0) {
    rowStyle = {
      ...rowStyle,
      ...styles.rowWithBorder,
    };
  }

  const itemKey = !isNil(alternateItemKey) ? item[alternateItemKey] : item.id;

  const Wrapper = hasHorizontalPadding ? Gutter : View;
  const textScalingProps = {
    allowFontScaling: true,
    maxFontSizeMultiplier: 2,
  };
  // item.lastOrderedOn = get(item, 'entryDate', '');
  const itemWithLastOrderedOn = {
    ...item,
    lastOrderedOn: get(item, 'entryDate', ''),
  };

  const onPress = () =>
    onRecordPress({recordType: CLIENT_PROFILE, recordId: item.id});

  return (
    <Wrapper style={rowStyle}>
      <PersonListItem
        readonly={!onRecordPress}
        onPress={onPress}
        key={itemKey}
        isCoach={personIsCoach(itemWithLastOrderedOn)}
        avatarUrl={getPersonAvatarUrl(itemWithLastOrderedOn)}
        avatarEmail={getPersonAvatarEmail(itemWithLastOrderedOn)}
        name={<PersonNameComponent item={itemWithLastOrderedOn} />}
        role={<PersonRoleComponent item={itemWithLastOrderedOn} />}
        attribute={<PersonInfoComponent item={itemWithLastOrderedOn} />}
        newLabel={
          NewLabelComponent && (
            <NewLabelComponent item={itemWithLastOrderedOn} />
          )
        }
        style={
          isPeopleToContactSection && {base: styles.clientsToContactBaseStyle}
        }
        isCenterAlignedEvenlySpaced={isPeopleToContactSection}
        {...textScalingProps}
      />
    </Wrapper>
  );
};
